<template>
  <div class="form-item" v-show="visible">
    <el-form ref="childForm" :rules="rules" :model="formLabelAlign" label-position="top">
      <el-form-item style="text-align:left" :label="localized(`label`)" prop="value">
          <div class="id-options" v-show="showVIDSetting">
          <div style="width:50px; height: 40px; display: flex; justify-content: center; align-items: center;" @click="switchDataSource">
               <img src="@/assets/vidsetting.png" width="24px" height="24px" />
           </div>
        </div>
        <div class="vid-list" v-bind:class="{ ve_disable: formCannotEdit }" :style="vidErrorStyle">
          <div class="left-content">
              <div class="vid-container">
                  <div @click="callApp('view')" style="height:40px; width: 100%; padding-top:40px; display:flex; align-items: center; justify-content: center; flex-direction:column">
                    <span style="margin-top: 15px; margin-left: 10px; line-height: 14px; flex: 1; text-align:center; width: 100%; font-size:14px; font-weight: 600"><span v-if="showContent">[{{idType}}]</span> {{showContent}}</span>
                    </div>
                  <el-input v-model="showContent" style="visibility: hidden"></el-input>
                  <span style="color: rgb(198, 202, 209)" v-if="itemdata == ''">{{item.prompt || ''}}</span>
              </div>
              <i class="el-icon-arrow-right"></i>
          </div>
          <div class="right-scanner" v-if="!vidDisable">
            <a v-show="!vidDisable" @click="callApp()">
              <img src="@/assets/scan.png" width="20px"/>
              <span style="font-size:8px; line-height:10px;margin-top:5px; color: #409eff">{{idType}}</span>
            </a>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="$t('app.scan_dialog_title')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="disabled"
      :custom-class="vidResultDialogClass"
      top="0"
      width="90%"
    >
      <div class="scan-customid-range" style="line-height: 30px; font-size: 15px" v-if="customIDRange">
          <div class="start">
            <span>{{$t("app.vid_startingcode")}}</span>
            <span style="margin-left:20px">{{customId.begin}}</span>
          </div>
            <div class="end">
            <span>{{$t("app.vid_endingcode")}}</span>
            <span style="margin-left:20px">{{customId.end}}</span>
          </div>
      </div>
      <div class="card-options" style="display: flex; justify-content: space-between">
        <h3 style="font-weight: 400; color: #000; margin-left: 2px">{{$t("app.scaned_id_list")}}</h3>
        <h3 style="font-weight: 400; color: #000; margin-right: 2px" @click="clearAll" v-if="!formCannotEdit">{{removeIdTitle}}</h3>
      </div>
      <el-card class="box-card" style="height:57vh">
        <div slot="header" class="clearfix">
          <div class="vid-content-header" style="display: flex; justify-content: space-between">
              <div class="vid-count-summray">
                  <span style="font-weight: 500;">{{$t('app.scan_result_total')}}: {{rfidData.length}}</span>&nbsp;
                  <span
                    style="color: orangered;"
                  >{{$t('app.scan_result_fail')}}: {{failRfidData.length}}</span>
              </div>
              <span>{{idType}}</span>
          </div>
        </div>
        <div class="scan-result" v-for="data in rfidData" :key="data.vid">
          <div class="left" @click="showVid(data)">{{data.vid && regVid(data.vid)}}
            <span v-if="data.message" @click="showVid(data)" class="el-icon-warning" style="text-color: orangered;"></span>
          </div>
          <div class="right" v-if="!formCannotEdit">
            <span class="status">
              <i
                class="el-icon-delete"
                style="font-size: 20px;"
                :style="{color: data.code == 1 ? 'lawngreen' : 'orangered'}"
                @click="delVid(data.vid)"
              ></i>
            </span>
            <span class="clearVid"></span>
          </div>
        </div>
        <div v-if="!rfidData.length" class="no-data">{{$t('app.no_data')}}</div>
      </el-card>
      <div
        class="scan_tip"
        v-if="type !== 'view'"
      >{{selectedScanType && $t('app.' + selectedScanType.split('.')[0] + '_msg')}}</div>
      <span slot="footer" class="dialog-footer" v-if="!disabled">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7" v-if="isIos ||  scanSelect.indexOf('qr') > -1">
            <el-button
              @click="Add"
              size="small"
              round
              :disabled="disabled || vidDisable"
              class="btn-white-color"
            >{{$t('app.btn_add')}}</el-button>
          </el-col>
          <el-col :span="isIos ||  scanSelect.indexOf('qr') > -1 ? 7 : 11">
            <el-button
              @click="clear"
              size="small"
              round
              class="btn-white-color"
            >{{$t('app.btn_clear')}}</el-button>
          </el-col>
          <el-col :span="isIos ||  scanSelect.indexOf('qr') > -1 ? 7 : 11">
            <el-button
              class="btn-black-color"
              v-if="failRfidData.length"
              round
              @click="delAllFailData"
              size="small"
            >{{$t('app.del_all')}}</el-button>
            <el-button
              class="btn-black-color"
              v-if="!failRfidData.length"
              round
              :disabled="disabled || vidDisable"
              @click="confirm"
              size="small"
            >{{$t('app.btn_confirm')}}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('app.choose_dialog_title')"
      top="20vh"
      width="90%"
      :visible.sync="dialogChooseVisable">

      <template v-for="scan in scanSources">
        <div class="scan-item" v-if='scan.disabled'>
          {{$t(`app.${scan.text}`)}}
          <span :class="{ 'el-icon-check': selectType === scan.value }"></span>
        </div>
        <div @click="selectScan(scan)" :class="{ 'active-selected-scan': selectType === scan.value }" class="scan-item" v-else>
          {{$t(`app.${scan.text}`)}}
          <span :class="{ 'el-icon-check': selectType === scan.value }"></span>
        </div>
      </template>
      <el-radio-group
        v-model="selectNum"
        size="small"
        v-if="selectType && scanColl[selectType] && scanColl[selectType].length > 1"
        class="vid-source-radio"
        style="flex-wrap: wrap; width: 100%; height: auto; display: flex;"
      >

        <template v-for="(type, index) in scanColl[selectType]">
          <div style="width:50%; display:flex; justify-content: flex-start;">

              <el-radio
                style="line-height: 30px;"
                :key="type.type"
                :label="type.type"
                :disabled="type.disabled"
                >{{$t(`app.${type.type}`)}}</el-radio>
          </div>
        </template>

      </el-radio-group>

      <el-radio-group size="small" v-if="!selectType" class="vid-source-radio">

        <el-row type="flex" class="row-bg" justify="start">
          <el-col :span="12" class="qr_items">
          <el-radio style="line-height: 30px;" label="single" disabled>{{$t('app.single')}}</el-radio>
          </el-col>
          <el-col :span="12" class="qr_items">
            <el-radio style="line-height: 30px;" label="multi" disabled>{{$t('app.multi')}}</el-radio>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="start" v-if="isCustomIdVersion()">
          <el-col :span="12" class="qr_items">
            <el-radio style="line-height: 30px;" label="customid_single" disabled>{{$t('app.customid_single')}}</el-radio>
          </el-col>
          <el-col :span="12" class="qr_items">
            <el-radio style="line-height: 30px;" label="customid_multi" disabled>{{$t('app.customid_multi')}}</el-radio>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="start" v-if="isCustomIdVersion()">
          <el-col :span="12" class="qr_items">
            <el-radio style="line-height: 30px;" label="customid_range" disabled>{{$t('app.customid_range')}}</el-radio>
          </el-col>
        </el-row>

      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 20px;">
          <el-col :span="11">
            <el-button
              @click="dialogChooseVisable = false"
              size="small"
              round
              class="btn-white-color"
            >{{$t('app.btn_clear')}}</el-button>
          </el-col>
          <el-col :span="11">
            <el-button
              class="btn-black-color"
              round
              :disabled="!selectNum || !selectType"
              @click="confirmSelect"
              size="small"
            >{{$t('app.btn_save')}}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog :title="idType" :visible.sync="centerDialogVisible" width="70%" center>
      <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction:column">
          <span style="font-size: 16px">{{currentVid.vid}}</span>
          <div style="margin-top: 10px;border: 1px solid #ddd; border-radius: 5px">
            <span v-if="currentVid.message" style="margin: 10px;font-size: 14px; font-weight: 600;" class="el-icon-info">
              <span style="margin-left: 5px">{{currentVid.message}}</span>
            </span>
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "@/utils";
import callApp from "@/services/sdk";
import language from '@/lang';
import appLocal from '@/i18n/en-US';
export default {
  name: "vid-widget",
  uuid: "00000000-0000-0000-0000-000000100007",
  props: ["jsonContent", "fatherContent", "datamodel", "disabled", "host", "contextData", "editStatus"],
  data() {
    return {
      flag: 0,
      currentVid: "",
      centerDialogVisible: false,
      type: "",
      dialogVisible: false,
      rfidData: [],
      failRfidData: [],
      scanSources: [],
      dialogChooseVisable: false,
      dialogSourceVisable: false,
      scanSelect: "",
      selectType: "",
      selectNum: "single",
      scanColl: {},
      currentSource: "local.scanner",
      formLabelAlign: {
        value: ""
      },
      vidType: 0,
      showContent: "",
      isIos: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      idType: this.$t("app.id_type_vid"),
      vidSourceType: "vid",
      customId: {
        begin: "",
        end: "",
        list: []
      }
    };
  },
  computed: {
    ...mapGetters({
      scanType: "getCurrentScanType",
      formStatus: "getFormStatus",
      bigVid: "getBigVid",
      dataPointType: "getDataPointType",
      dataInfo: "getDataInfo",
    }),
    selectedScanType() {
      if (this.showVIDSetting){
        return this.scanSelect
      }
      return this.scanType
    },
    showVIDSetting() {
      return this.$store.state.vidlistComponents.length > 1 && this.isCustomIdVersion()
    },
    vidErrorStyle() {
        let vidHasError = false
        if(this.errorVidDataInfo === undefined || (this.errorVidDataInfo && this.errorVidDataInfo.length <= 0)){
          return "border-color: #dcdfe6"
        }
        this.errorVidDataInfo.forEach(errorVid=>{

          (this.rfidData || []).forEach(readVid=>{
            if(readVid.vid  === errorVid.vid){
              vidHasError = true
            }
          })
        })
        if (vidHasError) {
          return "border-color: red"
        }
        return "border-color: #dcdfe6"
    },
    errorVidDataInfo() {
      if (this.dataInfo === undefined) {
        return undefined
      }
      let vidErrorData = this.getErrorIdList(this.dataInfo)

      let errorVidList = vidErrorData.map(item=>{
        let errorCode = item.code

        let errorCodeIndex = -1
        Object.keys(appLocal.app.viderror).forEach(viderror=>{
            if (parseInt(viderror) === parseInt(errorCode)) {
              errorCodeIndex = 0
            }
        })
        if(errorCodeIndex <= -1){
            errorCode = "default"
        }

        let idlist = item.vid && item.vid.split(",") || []
        let vid = idlist[1] || idlist[0]
        return {vid, message: this.$t('app.viderror.' + errorCode)}
      })
      return errorVidList
    },
    removeIdTitle() {
        if (this.failRfidData.length > 0) {
          return this.$t("app.delete_execption_id")
        }
        return this.$t("app.delete_all_id")
    },
    vidResultDialogClass(){
      if(this.customIDRange){
        return "scan-dialog-range"
      }
      return "scan-dialog"
    },
    currentType() {
      return this.dataPointType === "collectionUnBind" ||
        this.dataPointType === "collectionBind"
        ? (this.fatherContent.key || "").toLowerCase() === "bigvid"
          ? "bigvid"
          : "subvid"
        : "";
    },
    formCannotEdit() {
				return (this.formStatus === 'submitedit'
          && (this.dataPointType === 'bind'
            || this.dataPointType === 'collectionUnBind'
            || this.dataPointType === 'collectionBind')
          || !this.fatherContent.displayReference.editable || this.disabled
        )
    },
    customIDRange() {
      return this.selectNum && this.selectNum.indexOf("customid_range") > -1
    },
    item() {
      return this.fatherContent.controlReference;
    },
    item_name() {
      return this.fatherContent.key
    },
    rules() {
      return {
      value: [
        {
          type: "array",
          required: this.fatherContent.controlReference.required,
          message: "Required",
          trigger: "blur"
        }
      ]
    }
    },
    itemdata: {
      get() {
        if (this.datamodel && this.datamodel.vidlist) {
          this.rfidData = this.datamodel.vidlist.map(vid => {

            let message = undefined
            this.errorVidDataInfo && this.errorVidDataInfo.forEach(item=>{

                if(item.vid === vid) {
                    message = item.message
                }
            })
            let vidCode = 1
            if(message !== undefined){
              vidCode = 0;
            }
            return {
              vid: vid,
              message,
              code: vidCode
            };
          });

          if (this.item.max === 1) return this.datamodel.vidlist[0];
          return this.datamodel.vidlist && this.datamodel.vidlist.length
            ? this.datamodel.vidlist.length
            : "";
        } else {
          return "";
        }
      },
      set(val) {
        if (!val) {
          this.$nextTick(_ => {
            this.showContent = ""
          })
          this.formLabelAlign.value = []
          return false
        };
        let data = {
          vidlist: val ? this.rfidData.map(data => data.vid) : [],
          type: 0
        };
        this.formLabelAlign.value = data.vidlist
        let vidListLength = data.vidlist && data.vidlist.length || 0
        if (this.item.max === 1 || vidListLength <= 1) {
          let showVid = data.vidlist[0]
          let vid = showVid.replace(showVid.substring(6, showVid.length - 6), "......");
          if (data.vidlist[0].length <= 12) {
            vid = showVid
          }
          this.$nextTick(_ => {
            this.showContent = vid
          })
        }else{
          this.$nextTick(_ => {
            this.showContent = data.vidlist.length
          })
        }
      }
    },
    visible() {
      if (this.fatherContent.itemType) {
        return this.fatherContent.itemType.displayReference.visible
      }
      return this.fatherContent.displayReference.visible
    },
    hostKey(){
      return this.host + "." + this.fatherContent.key
    },
    vidDisable() {
      return this.dataPointType === 'bind' && (this.formStatus === 'submitedit')
    },
    versionCode() {
      return this.$store.state.versionCode
    }
  },
  watch: {
    bigVid: function() {
      this.flag++
      this.$nextTick(() => {
      	if (this.formStatus !== 'init' && this.flag > 1) {
      		if (this.currentType === 'subvid') {
      			this.rfidData = []
      			this.failRfidData = []
      			this.$nextTick(() => {
      				this.itemdata = ''
      			})
      		}
      	}

      })
    },
    formLabelAlign: {
      handler(val) {
        console.log("this.vidSourceType", this.vidSourceType)
        let type = this.vidSourceType === "customid" ? 1 : 0
        this.vidType = type
        var data = {
          vidlist: val.value,
          type: type,
          num: (val.value && val.value.length) || 0,
        }
        if(val.value === undefined || val.value === "" || val.value === []){
          data = undefined
        }
        this.$emit("fatherCall", {
          key: this.fatherContent.key,
          value: data
        });
      },
      deep: true
    },

    selectNum: {
      handler(type) {
        if(type && type.indexOf("customid") > -1) {
          this.idType = this.$t('app.id_type_custom')
          this.vidSourceType = "customid"
        }else{
          this.idType = this.$t('app.id_type_vid')
          this.vidSourceType = "vid"
        }
      }
    }
  },
  created() {
    const _this = this;
    this.$store.state.vidlistComponents.push(this); // 缓存vid组件实例
    window["web.closeScanDialog"] = () => {
      this.$store.state.vidlistComponents.forEach(instance => {
        // 切换扫描类别时, 关闭扫描的弹窗
        instance.dialogVisible = false;
      });
    };
    window["web.setVidSource"] = () => {
      this.getVidSource()
    };
  },
  mounted() {

    // this.formLabelAlign.value = this.datamodel && this.datamodel.vidlist;
    // console.log("this.datamodel", this.datamodel)
    // console.log("vid_list_count", this.$store.state.vidlistComponents.length)
    if(this.datamodel){
      if(this.datamodel.type === 1){
        this.idType = this.$t('app.id_type_custom')
        this.vidSourceType = "customid"
        this.formLabelAlign.value = (this.datamodel.vidlist || []).map(item=>{
          let idlist = item.split(",")
          return idlist[1] || idlist[0]
        })
      }else{
        this.idType = this.$t('app.id_type_vid')
        this.vidSourceType = "vid"
        this.formLabelAlign.value = this.datamodel.vidlist
      }
      /// merge errorVidDataInfo & failvid
      this.errorVidDataInfo && this.errorVidDataInfo.forEach(item=>{

            if (item.vid && !this.isExisted(this.failRfidData, item)) {
              this.failRfidData.push({
                  vid: item.vid,
                  key: Math.random()
                })
            }
        })
    }

    // console.log("this.formLabelAlign.value", this.formLabelAlign.value)
    // if(this.$store.state.vidlistComponents.length > 1){
    this.getStoredVidSource()
    // }
    this.solveBigVid();

    if(this.datamodel && this.datamodel.type === 1){
      this.datamodel.vidlist = this.datamodel.vidlist.map(item=>{
          let idlist = item.split(",")
          return idlist[1] || idlist[0]
      })
    }

    if(this.item.max === 1){

        let showVid = this.datamodel && this.datamodel.vidlist[0]
        let vid = showVid
        if (showVid && showVid.length > 12){
          vid = showVid.replace(showVid.substring(6, showVid.length - 6), "......");
        }

        this.$nextTick(_ => {
          this.showContent = vid
        })
    }else{
      this.showContent = this.datamodel && this.datamodel.vidlist && this.datamodel.vidlist.length
    }
  },
  methods: {
    localized(key){
        return language.localize(this.$store.state,this.fatherContent.key, key, this.fatherContent.displayReference[key])
    },
    showVid(vid) {
      this.currentVid = vid;
      this.centerDialogVisible = true;
    },
    regVid(vid) {
      if (!vid || typeof vid !== "string" || vid.length <= 12) return vid;
      return vid.replace(vid.substring(6, vid.length - 6), "......");
    },
    Add() {
      this.callBack();
    },
    delAllFailData() {
      this.failRfidData = [];
      this.rfidData = this.rfidData.filter(vid => vid.code == 1);
    },
    delVid(vid) {
      if (this.formCannotEdit) return;
      let totalIndex;
      let failIndex;
      this.rfidData.forEach((item, index) => {
        if (item.vid === vid) {
          totalIndex = index;
        }
      });
      this.failRfidData.forEach((item, index) => {
        if (item.vid === vid) {
          failIndex = index;
        }
      });
      if (totalIndex !== undefined) {
        this.rfidData.splice(totalIndex, 1);
      }
      if (failIndex !== undefined) {
        this.failRfidData.splice(failIndex, 1);
      }
    },
    clearAll() {
      if(this.disabled) {
        return
      }
      if(this.failRfidData.length) {
        this.delAllFailData()
        return
      }
      this.rfidData = [];
      this.failRfidData = [];
    },
    getStoredVidSource(callback) {

      let data = {}
      if (this.showVIDSetting) {
        let key = this.hostKey
        data = {key: this.hostKey}
      }

      callApp(
      "getSelectedVidSource",
      {
        type: "storage.getSelectedVidSource",
        data
      },
      "cbGetSelectedVidSource"
    ).then(resData => {

      let selectVidSourceType = resData && resData.split(".")[0];
      let selectVidFunc = resData && resData.split(".")[1];

      // console.log("selectVidFunc", selectVidFunc)
      // console.log("resData", resData)
      /// vid 编辑
      if(this.datamodel && this.datamodel.vidlist && this.datamodel.type === 0) {
          if(selectVidFunc.indexOf('customid') > -1){
              callback && callback()
              return
          }
      }
      else if(this.datamodel && this.datamodel.vidlist && this.datamodel.type === 1) {
        /// customId 编辑
        if(selectVidFunc.indexOf('customid') < 0){
            callback && callback()
            return
        }
      } else {
          this.selectType = selectVidSourceType
          this.selectNum = selectVidFunc
      }

      // console.log("selectNum", this.selectNum)
      this.scanSelect = resData;
      if (!this.showVIDSetting){
        this.$store.dispatch("setCurrentScanType", resData);
      }
      callback && callback()
      });
    },
    clear() {
      // 取消后先清空当前显示数据，再从已经选中的数据中装值
      this.rfidData = [];
      this.failRfidData = [];
      if (this.datamodel && this.datamodel.vidlist) {
        // 关闭之后要同步一下当前select 的value
        this.rfidData = this.datamodel.vidlist.map(vid => {

            let message = undefined
            this.errorVidDataInfo && this.errorVidDataInfo.forEach(item=>{

                if(item.vid === vid) {
                    message = item.message
                }
            })
            let vidCode = 1
            if(message !== undefined){
              vidCode = 0;
            }
            return {
              vid: vid,
              message,
              code: vidCode
            };
          });
        /// add message
        this.errorVidDataInfo && this.errorVidDataInfo.forEach(item=>{

            if (item.vid && !this.isExisted(this.failRfidData, item)) {
              this.failRfidData.push({
                  vid: item.vid,
                  key: Math.random()
                })
            }
        })
      }
      this.dialogVisible = false;
      callApp(
        "getData",
        {
          type: `device.closeScan`,
          data: this.selectedScanType
        },
        "cbGetData"
      );
    },
    confirm() {
      let result = [];
      console.log("confirm_this.rfidData", this.rfidData)
      this.rfidData.forEach(item => {
        if (item.code === 1) {
          result.push(item.vid);
        }
      });
      if (this.item.max === 1) {
        // 这边处理的原因是因为 confirm 后，页面上绑定的itemdata不会触发get钩子
        if (result.length === 1) {
          this.itemdata = result[0];
        } else if (result.length > 1) {
          this.itemdata = result.length;
        } else {
          this.itemdata = "";
        }
      } else {
        console.log("result.length", result.length)
        this.itemdata = result.length || "";
      }

      this.$nextTick(() => {
        this.solveBigVid();
      });
      this.dialogVisible = false;
      callApp(
        "getData",
        {
          type: `device.closeScan`,
          data: this.selectedScanType
        },
        "cbGetData"
      );
      /// update vid
    },
    selectScan(scan) {
      this.selectType = scan.value;
      this.selectNum = "single";
      if(this.datamodel && this.datamodel.vidlist && this.datamodel.type === 1) {
        this.selectNum = "customid_single";
      }
    },
    confirmSelect() {

      this.scanSelect = this.selectType + "." + this.selectNum;
      let data = this.isCustomIdVersion() ? {val: this.scanSelect} : this.scanSelect
      if (this.showVIDSetting) {
        let key = this.hostKey
        data = this.isCustomIdVersion() ? {key: this.hostKey, val: this.scanSelect} : this.scanSelect
      }

      if(!this.datamodel) {
        this.rfidData = []
        this.failRfidData = []
        this.$nextTick(() => {
          this.itemdata = ''
        })
      }

      this.$nextTick(() => {
        callApp(
          "updateSelectedVidSource",
          {
            type: "storage.updateSelectedVidSource",
            data
            // data: this.scanSelect
          },
          "cbUpdateSelectedVidSource"
        ).then(data => {
          this.dialogChooseVisable = false;
          if (!this.showVIDSetting){
            this.$store.dispatch("setCurrentScanType", this.scanSelect);
          }
        });
      });
    },
    isCustomIdVersion() {
      return ~~this.versionCode >= 10
    },
    selectDataSource() {
      this.dialogSourceVisable = false;
      this.callApp();
    },
    createRandom() {
      return (
        +new Date() +
        Math.random()
          .toString()
          .substr(2, 4)
      );
    },
    callBack() {
      this.dialogVisible = true;
      const requestId = this.createRandom();
      const bigVid = this.currentType === "subvid" ? this.bigVid : void 0;
      console.log("bigVid:", bigVid)
      console.log("scanType:", this.selectedScanType)
      callApp(
        "getData",
        {
          type: `dataSource.${this.selectedScanType}`,
          data: {
            max: this.item.max - this.rfidData.length,
            bigVid
          }
        },
        "cbGetData",
        "",
        requestId
      ).then(data => {
        if (!this.isIos) {
          // 安卓因为多扫，所以扫描的逻辑不同
          window["web.setVidData" + requestId] = data => {
            if (this.item.max - (this.rfidData.length + data.length) < 0) {
              this.$toast({
                message: this.$t("app.scan_limit"),
                position: "center",
                iconClass: "icon el-icon-warning",
                duration: "3000"
              });
              return;
            }
            this.customId.begin = data.begin || ""
            this.customId.end = data.end || ""

            console.log("item_max,",this.item.max)
            if (this.item.max > 1) {
              data.vids.forEach(item => {
                if (item.vid && !this.isExisted(this.rfidData, item)) {
                  // all, 重复的vid会被覆盖
                  /// add message
                  this.rfidData.push(item);
                  if (item.code != 1) {
                    //record fail
                    this.failRfidData.push({
                      vid: item.vid,
                      key: Math.random()
                    });
                  }
                } else {
                  let index;
                  if (item.code == 1) {
                    this.failRfidData.filter((data, i) => {
                      if (data.vid === item.vid) {
                        index = i;
                      }
                    });
                  }
                  index !== undefined && this.failRfidData.splice(index, 1);
                }
              });
              let scanCardDom = document.querySelector(
                ".box-card .el-card__body"
              );
              scanCardDom.scrollTop =
                scanCardDom.scrollHeight - scanCardDom.offsetHeight + 40;
            } else {
              /// add message
              this.rfidData = data.vids;
              this.failRfidData = data.vids.filter(vid => vid.code != 1);
            }
          };
        } else {
          // ios逻辑
          console.log("data:", data)

          this.customId.begin = data.begin || ""
          this.customId.end = data.end || ""

          console.log("item_max,",this.item.max)
          if (this.item.max > 1) {
            data.vids.forEach(item => {
              if (item.vid && !this.isExisted(this.rfidData, item)) {
                // all, 重复的vid会被覆盖
                /// add message
                this.rfidData.push(item);
                if (item.code != 1) {
                  //record fail
                  this.failRfidData.push({ vid: item.vid, key: Math.random() });
                }
              } else {
                let index;
                if (item.code == 1) {
                  this.failRfidData.filter((data, i) => {
                    if (data.vid === item.vid) {
                      index = i;
                    }
                  });
                }
                index !== undefined && this.failRfidData.splice(index, 1);
              }
            });
            let scanCardDom = document.querySelector(
              ".box-card .el-card__body"
            );
            scanCardDom.scrollTop =
              scanCardDom.scrollHeight - scanCardDom.offsetHeight + 40;
          } else {
            /// add messages
            this.rfidData = data.vids || data.customIds;
            this.failRfidData = (data.vids || data.customIds).filter(vid => vid.code != 1);
            console.log("rfidData,",this.rfidData)
          }
        }
      });
    },
    mapScanType(type){
        let scan_type = {type: type, disabled: false}
        if(this.datamodel && this.datamodel.vidlist && this.datamodel.type === 0) {
            if(scan_type.type.indexOf('customid') > -1){
                scan_type = {type: type, disabled: true}
            }
        }
        else if(this.datamodel && this.datamodel.vidlist && this.datamodel.type === 1) {
          /// customId 编辑
          if(scan_type.type.indexOf('customid') < 0){
              scan_type = {type: type, disabled: true}
          }
        }

        /// bigvid
        if (this.currentType === 'bigvid' && scan_type.type.indexOf('single') < 0) {
            scan_type = {type: type, disabled: true}
        }

        return scan_type
    },
    getVidSource() {

      this.getStoredVidSource(()=>{

          this.scanColl = {};
          callApp(
            "getVidSource",
            {
              type: "device.vidSource",
              data: {
                max: this.item.max
              }
            },
            "cbGetVidSource"
          ).then(data => {
            this.$store.state.vidlistComponents.forEach(instance => {
              // 切换扫描类别时, 关闭扫描的弹窗
              instance.dialogVisible = false;
            });
            if (this.scanSelect) {
              this.selectType = this.scanSelect.split(".")[0];
              this.selectNum = this.scanSelect.split(".")[1];
            }
            this.scanSources = data.vidSources
              .map(item => {
                let scan = item.split(".");
                if (this.scanColl[scan[0]]) {

                  let scan_type = this.mapScanType(scan[1])
                  console.log("scan_type", scan_type)
                  this.scanColl[scan[0]].push(scan_type);
                } else {

                  /// disable nfc for cutomid
                  let scan_type = this.mapScanType(scan[1])

                  this.scanColl[scan[0]] = [scan_type];
                  let disabled = false
                  if(this.datamodel && this.datamodel.type === 1){
                    if(scan[0].toLowerCase() === 'nfc') {
                        disabled = true
                    }
                  }
                  return { text: scan[0], value: scan[0], disabled };
                }
              })
              .filter(item => item !== undefined);
            console.log("scanSource:", this.scanSources)
            this.$nextTick(_ => {
              this.dialogChooseVisable = true;
            });
          });
      })
    },
    switchDataSource(){
      if (this.disabled) {
        return;
      }
      this.getVidSource()
    },

    callApp(type) {
      console.log("call_app", type)
      console.log("currentSource", this.currentSource)
      console.log("selectedScanType", this.selectedScanType)
      console.log("scanSelect", this.scanSelect)
      console.log("scanType", this.scanType)
      if (this.disabled && !type) {
        return;
      }
      if(type === "view" && this.disabled){
        this.dialogVisible = true;
        return
      }
      if (!this.currentSource) {
        this.dialogSourceVisable = true;
      } else {
        // this.rfidData = []
        // this.failRfidData = []
        console.log("bigvid", this.item_name)
        console.log("bigvid", this.currentType)
        console.log("scanType", this.selectedScanType)
        if (this.currentSource.toLowerCase().indexOf("local.scanner") > -1) {
          // scanner
          if (this.currentType === "bigvid" && (this.selectedScanType && this.selectedScanType.indexOf('single') <= -1)){
            this.scanSelect = undefined;
            this.getVidSource();
            return;
          }
          if (!this.selectedScanType) {
            this.getVidSource();
            return;
          }
          this.dialogVisible = true;
          if (type === "view") {
            this.type = "view";
            return;
          }
          this.type = "";
          this.callBack();
        } else {
          callApp(
            "getData",
            {
              type: this.currentSource,
              data: { max: this.item.max, min: this.item.min }
            },
            "cbGetData"
          );
        }
      }
    },
    solveBigVid() {
      if (this.currentType === "bigvid") {
        this.$store.dispatch("setBigVid", this.itemdata);
      }
    },
    isExisted(ary, item) {
				let flag
				ary.forEach((data, index) => {
          var dataVid = data.vid && data.vid.toLowerCase()
					var itemVid = item.vid && item.vid.toLowerCase()
					if (dataVid === itemVid) {

						flag = index
						this.$set(ary, index, item) // 重复的vid会被覆盖
					}
				})
				return flag !== undefined
			},
    getErrorIdList(params) {
      // 从DCP 列表ITEM中获取vid错误列表
      if (!params) {
        return []
      }
      let errorIdList = []
      let code
      if (typeof params === 'object') {
        code = params.code
        errorIdList = this.getVidErrorData(params.data) || []
      } else {
        code = eval('(' + params + ')').code
        errorIdList = this.getVidErrorData(eval('(' + params + ')').data) || []
      }

      return errorIdList
    },
    getVidErrorData(data) {
      if (typeof data === 'object') {
        return data
      } else {
        return eval('(' + data + ')')
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-item {
  margin-top:10px;
}
.item-label {
  span {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
}
.scan-item {
  line-height: 40px;
  border-bottom: 1px solid #e8e8e8;
}

.active-selected-scan {
  font-weight: 500;
  color: #000000;

  span {
    display: inline-block;
    float: right;
    line-height: 40px;
    font-weight: 700;
  }
}
.qr_items {
  display: flex;
  flex: 1;
  justify-content: flex-start;
}
.qr_item_radio {
  justify-content: flex-start;
}

.vid-prefix-label {
  line-height:20px;
  max-width: 120px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #666;

  .right-border {
    width: 2px;
    height: 12px;
    background-color: #999;
  }
}

  .vid-source-radio {
    display: block;
    margin-top: 30px;
    text-align: center;

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #000;
      background: #000;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #000;
    }
  }

.nfc,
.infrared,
.deviceTime,
.gps {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 14px;
  word-break: break-word;
  overflow: hidden;
  padding-right: 6px;

  a {
    float: right;
    display: inline-block;
    width: 40px;
    height: 40px;
    position: relative;
  }

  span {
    display: inline-block;
    height: 100%;
    width: calc(100% - 45px);
  }

  &:active {
    border-color: #409eff;
  }

  .scan {
    position: absolute;
    right: 4px;
    top: 14px;
  }
}

.vid-list {
  height: 50px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  display: flex;
  justify-content: "flex-satrt";
  align-items: center;

  .left-content {
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: "flex-satrt";
    align-items: center;
    .vid-container {
      flex: 1;
    }
    i {
      width: 10px;
    }
  }

  .right-scanner {
    width: 60px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #dcdfe6;
    span {
      line-height: 24px;
    }
    a {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
    }
  }

  .scan {
    position: absolute;
    right: 4px;
    top: 14px;
  }
}

.vid-list-range {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  display: flex;
  justify-content: "flex-satrt";
  align-items: center;

  .left-content {
    padding: 10px;
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: "flex-satrt";
    align-items: center;
    .vid-container {
      flex: 1;
    }
    i {
      width: 10px;
    }
  }

  .right-scanner {
    width: 50px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #dcdfe6;
    span {
      line-height: 24px;
    }
    a {
      flex: 1;
      // text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
    }
  }

  .scan {
    position: absolute;
    right: 4px;
    top: 14px;
  }
}

.ve_disable {
  &:active {
    border-color: #dcdfe6;
  }
}

.scan_tip {
  margin-top: 10px;
  text-align: center;
  opacity: 0.8;
}

.box-card {
  .el-card__body {
    height: calc(100vh - 360px);
    overflow-y: scroll;

    .no-data {
      text-align: center;
      opacity: 0.5;
    }

    .scan-result {
      padding: 10px 0px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid lightgrey;

      .left {
        word-break: break-word;
      }

      .right {
        text-align: right;
        width: 90px;
      }
    }
  }
}

.id-options {
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  top: -40px;
  right: 1px;
}

</style>

